export function formatDate(strDate) {
  if (!strDate) {
    return '';
  }

  const date = new Date(strDate);
  return `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}`;
}